import React from "react";
import styled from "styled-components";

const Button=styled.div`
    cursor:pointer;
    border-radius:50%;
    height:25px;
    width:25px;
`;

function StatusButton(props)
{
    return (<React.Fragment>
            <Button style={{backgroundColor:`${props.status}` ,border:`5px solid ${props.status}`}}/>
        </React.Fragment>);
}

export default StatusButton;